module.exports = __webpack_public_path__ + "static/media/Times New Roman Bold.bed7bbf5.ttf";